export default "__VITE_ASSET__BK_ZyQaO__"